import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import UserApi from "../../apis/user.api";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import formatPhoneNumber from "../../utils/formatPhoneNumber";
import PhoneNumberModal from "./PhoneNumberModal";

const EditInfo = function () {
  const [openSuccessChangePhone, setOpenSuccessChangePhone] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { ceoInfo } = useAuth();
  const [userInfo, setUserInfo] = useState();

  let state = location.state;

  const defaultFormValues = {
    shop_name: "",
    biz_no: "",
    owner_name: "",
    owner_phone_no: "",
  };

  const schema = yup.object().shape({
    owner_name: yup.string().required(),
  });
  const { control, handleSubmit, watch, reset, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultFormValues,
  });

  const onSubmit = async (data) => {
    if (ceoInfo?.shop_idx) {
      const submitData = {
        shopIdx: ceoInfo?.shop_idx,
        shopName: data.shop_name,
        directorName: data.owner_name,
      };

      try {
        setLoading(true);
        await UserApi.editInfo(submitData);
        setUserInfo({
          ...data,
          owner_phone_no: formatPhoneNumber(data.owner_phone_no, true, 11),
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const values = watch();
  const handleCloseSuccessModal = () => {
    setOpenSuccessChangePhone(false);
    navigate(location.pathname, { replace: true, state: {} });
  };

  const getInfo = async () => {
    if (ceoInfo?.shop_idx) {
      const res = await UserApi.getInfo(ceoInfo?.shop_idx);
      if (res.data.data) {
        reset(res.data.data);
        if (res.data.data.owner_phone_no) {
          setValue(
            "owner_phone_no",
            formatPhoneNumber(res.data.data.owner_phone_no, true, 11)
          );
        }
        setUserInfo({
          ...res.data.data,
          owner_phone_no: formatPhoneNumber(
            res.data.data.owner_phone_no,
            true,
            11
          ),
        });
      }
    }
  };

  useEffect(() => {
    if (state && state.success && !openSuccessChangePhone) {
      setOpenSuccessChangePhone(true);
    }
  }, [state]);

  const isFormValuesSameAsDefault = () => {
    if (userInfo) {
      for (const key in values) {
        if (values[key] !== userInfo[key]) {
          return false;
        }
      }
      return true;
    }
  };

  useEffect(() => {
    getInfo();
  }, []);
  const onBack = ()=>{
    navigate(ROUTE_PATHS.More)
  }
  return (
    <div>
      <TopPageBack onBack ={onBack}>
        <b>정보 수정</b>
      </TopPageBack>
      <div className="mx-5">
        <div className="h-4"></div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            control={control}
            name="shop_name"
            placeholder="사업장 코드를 입력해주세요."
            label="사업장명"
            className="mb-5"
            backgroundWhite
          />
          <AppInput
            control={control}
            name="biz_no"
            placeholder="사업장 코드를 입력해주세요."
            label="사업자등록번호"
            className="mb-5"
            type="number"
            // disabled
            inputStyle={{border: 'none'}}
            readOnly={true}
          />

          <AppInput
            control={control}
            name="owner_name"
            placeholder="대표자 이름을 입력해 주세요."
            label="대표자명"
            className="mb-5"
            backgroundWhite
          />
          <div className="edit-info-phone">
            <AppInput
              control={control}
              name="owner_phone_no"
              placeholder="대표자 휴대폰 번호를 입력해 주세요."
              label="휴대폰 번호"
              maximum={11}
              isKoreaPhoneNumber
              type="number"
              inputStyle={{border: 'none'}}
              // disabled
              readOnly={true}
              className="edit-info-phone-input"
            />
            <button
              onClick={() => setOpenModal(true)}
              type="button"
              className="outline-blue-btn edit-info-phone-btn"
            >
              변경
            </button>
          </div>

          <div className="w-100 text-center delete-account-btn">
            <button
              onClick={() => {
                navigate(ROUTE_PATHS.DeleteAccount);
              }}
              type="button"
            >
              탈퇴하기
            </button>
          </div>

          <div className="px-5 absolute w-full bottom-2 left-0">
            <SolidBlueBtn
              disabled={
                !values.shop_name ||
                !values.owner_name ||
                isFormValuesSameAsDefault() ||
                loading
              }
              className="w-full mt-5  flex items-center justify-center"
              type="submit"
            >
              <Spinner isLoading={loading} />
              저장
            </SolidBlueBtn>
          </div>
        </form>
      </div>
      <PhoneNumberModal
        defaultPhoneNumber={values?.owner_phone_no}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <AppAlert
        title="휴대폰 번호 변경이 완료되었어요!"
        desc="지금부터 변경된 번호로 적용돼요."
        open={openSuccessChangePhone}
        onOk={handleCloseSuccessModal}
        okText="확인"
        type="success"
      />
    </div>
  );
};
export default EditInfo;
